<template>
  <div
    ref="calendarFrame"
    class="calendar"
  >
    <CalendarMonth
      v-for="(m, index) in calendarMonths"
      :key="index"
      :month="m"
      :selected-date="selectedDate"
      :handle-select-date="handleSelectDate"
    />
  </div>
</template>

<script>

import CalendarMonth from './CalendarMonth'

export default {
  name: 'TransactionsCalendar',
  components: {
    CalendarMonth,
  },
  props: {
    calendarMonths: {
      type: Array,
      required: true,
    },
    selectedDate: {
      type: Date,
      required: false,
      default: null,
    },
    selectDate: {
      type: Function,
      required: true,
    },
  },
  data: function () {
    return {
      shouldScrollToEnd: false,
    }
  },
  watch: {
    calendarMonths: function (value) {
      this.shouldScrollToEnd = true
    },
  },
  updated: function () {
    if (this.shouldScrollToEnd) {
      this.shouldScrollToEnd = false
      this.$refs.calendarFrame.scrollLeft = this.$refs.calendarFrame.scrollWidth
    }
  },
  mounted: function () {
    // Start the calendar view at the latest date (the rightmost spot)
    var maxScrollLeft = this.$el.scrollWidth - this.$el.clientWidth
    this.$el.scrollLeft = maxScrollLeft
  },
  methods: {
    handleSelectDate: function (transactionDate) {
      this.selectDate(transactionDate)
    },
  },
}

</script>
